import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap } from 'rxjs';
import { environment } from '../../../../../../environments/environment.development';
import { ErrorHandlingService } from '../../../../../core/services/error-handling.service';
import {
  DataLogsApiResponsePaginated,
  DataLogsQueryParams,
  TouchedUser,
} from './data-log.interface';
import { ApiResponse } from '../../../../../core/models/api-response.models';

@Injectable({
  providedIn: 'root',
})
export class DataLogService {
  private readonly API_URL = `${environment.apiUrl}`;
  private readonly dataLogsSubject =
    new BehaviorSubject<DataLogsApiResponsePaginated | null>(null);
  dataLogs$ = this.dataLogsSubject.asObservable();

  constructor(
    private readonly errorHandler: ErrorHandlingService,
    private readonly http: HttpClient
  ) {}

  private buildTemplateLogsQueryParams(
    queryParams: DataLogsQueryParams
  ): HttpParams {
    let params = new HttpParams()
      .set('Page', queryParams.page.toString())
      .set('PageSize', queryParams.pageSize.toString());

    if (queryParams.sortOrder) {
      params = params.set('sortOrder', queryParams.sortOrder);
    }

    if (queryParams.sort) {
      params = params.set('sort', queryParams.sort);
    }
    if (queryParams.caseId) {
      params = params.set('caseId', queryParams.caseId);
    }

    if (queryParams.startDataDateRange) {
      params = params.set(
        'startDataDateRange',
        queryParams.startDataDateRange.toString()
      );
    }
    if (queryParams.endDataDateRange) {
      params = params.set(
        'endDataDateRange',
        queryParams.endDataDateRange.toString()
      );
    }
    if (queryParams.startDateRange) {
      params = params.set(
        'startDateRange',
        queryParams.startDateRange.toString()
      );
    }
    if (queryParams.endDateRange) {
      params = params.set('endDateRange', queryParams.endDateRange.toString());
    }
    if (queryParams.dataAuditTypeId) {
      params = params.set(
        'dataAuditTypeId',
        queryParams.dataAuditTypeId.toString()
      );
    }
    if (queryParams.dataUnitType) {
      params = params.set('dataUnitType', queryParams.dataUnitType.toString());
    }
    if (queryParams.searchTerm) {
      params = params.set('searchTerm', queryParams.searchTerm.toString());
    }
    if (queryParams.dataUnitType) {
      params = params.set('dataUnitType', queryParams.dataUnitType.toString());
    }
    if (queryParams.startDateRange) {
      params = params.set(
        'startDateRange',
        queryParams.startDateRange.toString()
      );
    }
    if (queryParams.endDateRange) {
      params = params.set('endDateRange', queryParams.endDateRange.toString());
    }
    if (queryParams.userId) {
      params = params.set('userId', queryParams.userId.toString());
    }
    return params;
  }

  getDataLogs(
    queryParams: DataLogsQueryParams
  ): Observable<DataLogsApiResponsePaginated> {
    //implement user get
    const params = this.buildTemplateLogsQueryParams(queryParams);
    return this.http
      .get<DataLogsApiResponsePaginated>(
        `${this.API_URL}/BehaviorDataLog/list`,
        {
          params,
        }
      )
      .pipe(
        tap(response => this.dataLogsSubject.next(response)),
        catchError(error => this.errorHandler.handleError(error))
      );
  }
  getUsersTouchedCase(caseId: number): Observable<ApiResponse<TouchedUser[]>> {
    return this.http
      .get<ApiResponse<TouchedUser[]>>(
        `${this.API_URL}/behaviordatalog/users-touched-case`,
        {
          params: new HttpParams().set('caseId', caseId.toString()),
        }
      )
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
